import React from "react";
import { useRecoilState } from "recoil";
import { Display } from "../atom/Display";
import DisplayWhat from "./DisplayWhat";

const subCategories = [
  { name: "Profile Image" },
  { name: "Background Image" },
  { name: "Badges" },
  { name: "Font" },
  { name: "Rank Image" },
];

const MarketInfo = () => {
  const [items, setitems] = useRecoilState(Display);
  const active = items || "Profile Image";

  return (
    <div>
      {/* Category pills */}
      <div className="flex flex-wrap justify-center gap-2.5 sm:gap-3 mb-10">
        {subCategories.map((category) => (
          <button
            key={category.name}
            onClick={() => setitems(category.name)}
            className={`px-5 py-2.5 rounded-full font-poppins text-sm transition-all duration-300 border ${
              active === category.name
                ? "bg-reored border-reored text-white shadow-[0_0_20px_rgba(213,60,53,0.3)]"
                : "bg-white/5 border-white/15 text-white/60 hover:text-white hover:border-white/30"
            }`}
          >
            {category.name}
          </button>
        ))}
      </div>

      {/* Item grid */}
      <div className="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 sm:gap-7">
        <DisplayWhat />
      </div>
    </div>
  );
};

export default MarketInfo;
